import { render, staticRenderFns } from "./Dispose.vue?vue&type=template&id=50e470c8&scoped=true"
import script from "./Dispose.vue?vue&type=script&lang=js"
export * from "./Dispose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e470c8",
  null
  
)

export default component.exports